<div class="container">
  <div class="row">
    <div class="col-60">
      <div class="sectors-title">
        <app-section-title2 color="dark"
          [title]="staticContent?.title"></app-section-title2>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid p-0 bg-white spacer-slider-sectors">
  <div class="row m-0">
    <div class="col-60 p-0">
      <div class="d-flex flex-row justify-content-center w-100">
        <div class="w-100 container-fluid-960">
          <ng-container *ngIf="items">
            <div class="position-relative">
              <div class="swiper-container swiper-container-sectors" [swiper]="config">
                <div class="swiper-wrapper">
                  <div class="swiper-slide swiper-slide-sectors" *ngFor="let item of items">
                    <picture>
                      <img class="img-slide object-fit-cover"
                           [src]="item.image_header.path" [alt]="item.name">
                    </picture>
                  </div>
                </div>


              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container spacer-description">
  <div class="row">
    <div class="col-60">
      <div class="sectors-description-inner" [innerHTML]="staticContent?.content | safeHtml">
      </div>
    </div>
  </div>
</div>
